import $ from 'jquery';
import hcSticky from 'hc-sticky';

$('.highlighted-event__wrapper').on('click', function (e) {
    if (e.offsetX < 0) {
        $(this).parent().toggleClass('highlighted-event--active');
    }
});

if ($('.highlighted-event').length) {
    let Sticky;

    document.addEventListener('DOMContentLoaded', function () {
        Sticky = new hcSticky('.highlighted-event', {
            stickTo: 'body',
            top: $('#wpadminbar').length ? $('#wpadminbar').height() + 30 : 30,
            responsive: {
                765: {
                    disable: true,
                },
            },
        });
    });

    $(window).on('resize', () => {
        if ('undefined' !== typeof Sticky) {
            Sticky.refresh();
        }
    });
}
